/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
/* istanbul ignore file */

import { StyleSheet } from 'aphrodite/no-important';
import { fonts, lottieUtils, colors } from '@blend/consumer-components';
import { ConsumerAppConfigContext } from '../../contexts/appConfig';

const GLOBALS = '__GLOBAL_STYLES__';

const globalExtension = {
  selectorHandler: (selector: any, baseSelector: any, generateSubtreeStyles: any) =>
    baseSelector.includes(GLOBALS) ? generateSubtreeStyles(selector) : null,
};

const lottieStyles = lottieUtils.generateLottieStyles(colors.reflex);

// .extend currently isn't included in the Aphrodite types, and adding it is actually
// really tricky because it returns effectively a new copy of the entire Aphrodite API,
// which is hard to type without a lot of duplication.
const extended = (StyleSheet as any).extend([globalExtension]);

/**
 * These styles are globally applied across the app, although are no-importanted
 * so they can be overridden by any more explicit style.
 *
 * This pattern was taken from https://github.com/Khan/aphrodite/issues/139#issuecomment-266500624.
 */

export function createCSSGlobals(appConfig: ConsumerAppConfigContext) {
  const styles = extended.StyleSheet.create({
    [GLOBALS]: {
      a: {
        ...fonts.UntitledSans,
        color: appConfig.colors.action,
      },
      // Global styles that apply to Lottie loading animations only
      ...lottieStyles,
    },
  });

  extended.css(styles[GLOBALS]);
}
